import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api, fmtDateTime } from "@/lib/api";
import { Panel, Stat, Empty } from "@/admin/ui";
import { StarPartners } from "@/admin/StarPartners";

const Stars = ({ n }) => <span className="inline-flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-3.5 w-3.5 ${i <= n ? "fill-[#E0A43A] text-[#E0A43A]" : "text-[#D6DBD2]"}`} />)}</span>;

export const AdminRatings = ({ role }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/ratings").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return <p className="text-[#6B7F74]">{d === false ? "Could not load ratings." : "Loading…"}</p>;
  const total = d.reviews.length;
  return (
    <div className="space-y-6" data-testid="admin-ratings">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Average rating" value={d.average ?? "—"} hint="across all partners" tone="amber" testid="ratings-average" />
        <Stat label="Reviews" value={total} tone="green" />
        <Stat label="5-star" value={d.distribution[5] || 0} tone="green" />
        <Stat label="1–2 star" value={(d.distribution[1] || 0) + (d.distribution[2] || 0)} hint="follow up with these" tone="coral" />
      </div>
      <StarPartners role={role} />
      <div className="grid gap-6 xl:grid-cols-[1fr_1.3fr]">
        <Panel title="Partner leaderboard" sub="Sorted by average stars">
          {d.partners.map((p, i) => (
            <div key={p.staff_id} className="flex items-center justify-between border-b border-[#F0F2EC] py-2 text-sm" data-testid={`ratings-partner-${p.staff_id}`}>
              <span><b className="mr-2 text-[#6B7F74]">#{i + 1}</b>{p.name}</span><span className="flex items-center gap-2"><Stars n={Math.round(p.rating_avg)} /><b>{p.rating_avg}</b><span className="text-xs text-[#6B7F74]">({p.rating_count})</span></span>
            </div>
          ))}
          {!d.partners.length && <Empty>No partner has been rated yet.</Empty>}
        </Panel>
        <Panel title="Latest reviews">
          <div className="space-y-2">
            {d.reviews.slice(0, 50).map((r) => (
              <div key={r.booking_id} className="rounded-xl border border-[#E3E6DD] p-3 text-sm">
                <div className="flex items-center justify-between"><b>{r.partner} · {r.booking_id}</b><Stars n={r.stars} /></div>
                {r.comment && <p className="mt-1">“{r.comment}”</p>}<p className="text-[10px] text-[#6B7F74]">{fmtDateTime(r.at)}</p>
              </div>
            ))}
            {!total && <Empty>No reviews yet.</Empty>}
          </div>
        </Panel>
      </div>
    </div>
  );
};
